/**
 * Objeto representativo da estrutura base de um projeto
 *
 */
export default {
    id: 85,
    name: 'CONSTRUCT IN Demonstração',
    capture_dates: [
        '28/07/2021',
        '30/06/2021',
        '23/06/2021',
        '09/06/2021',
        '06/06/2021',
        '28/05/2021',
        '27/05/2021',
        '22/05/2021',
        '21/05/2021',
        '19/05/2021',
        '15/05/2021',
        '14/05/2021',
        '12/05/2021',
        '08/05/2021',
        '06/05/2021',
        '05/05/2021',
        '30/04/2021',
        '29/04/2021',
        '28/04/2021',
        '25/04/2021',
    ],
    permission: {
        level: 'admin',
    },
}
